var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container error"},[_c('div',{staticClass:"text-center error--con"},[_c('img',{staticClass:"mb-2",attrs:{"src":require("@/assets/images/common/warning.png"),"alt":"!"}}),_vm._v(" 요청하신 페이지를 찾을 수 없습니다 ")])])
}]

export { render, staticRenderFns }